import {
  XAxis,
  AreaChart,
  Area,
  Tooltip,
  ResponsiveContainer,
  LineChart,
  YAxis,
  CartesianGrid,
} from "recharts";
import ReportHelper from "@/app/core/util/helpers/ReportHelper";
import React, { useEffect, useState } from "react";
import { PropertiesController } from "@/app/core/base/controllers/PropertiesController";
import { DateHelper } from "@/app/core/util/helpers/DateHelper";

export default function VisitsReports({ realEstateId, startDate, endDate }) {
  const [data, setData] = useState({ total: 0, ticket: 0, count: 0 });
  const reportHelper = ReportHelper();

  useEffect(() => {
    loadReport();
  }, [startDate, endDate]);

  async function loadReport() {
    const reports =
      await PropertiesController.GetRealEstatePropertiesVisitsReport(
        realEstateId,
        startDate,
        endDate
      );

    process(
      reports.map((r) => ({
        month: r.month,
        visitas: r.visitsCount,
      }))
    );
  }

  function process(res) {
    let responses = reportHelper.base;

    for (let s in responses) {
      for (let i in res) {
        if (res[i].month === responses[s].value) {
          responses[s].visitas = parseInt(res[i].visitas);
          responses[s].corretores = parseInt(res[i].corretores);
        }
      }
    }
    console.log("Tickets", responses);
    setData(responses);
  }

  return (
    <div className="col-md-12" key={"ticketsReport"}>
      <div className="block block-rounded block-bordered">
        <ul className="nav nav-tabs nav-tabs-block align-items-center border-bottom">
          <li className="nav-item">
            <a
              className="nav-link text-body-color active"
              href="javascript:void(0)"
            >
              Visitas nos seus anúncios
            </a>
          </li>
        </ul>
        {data && data ? (
          <div className="block-content block-content-full">
            <ResponsiveContainer height={300} key={"ativos"}>
              <AreaChart
                width={400}
                height={400}
                data={data}
                margin={{ top: 5, right: 20, left: 10, bottom: 5 }}
              >
                <XAxis dataKey="name" />
                <Tooltip />
                <Area
                  type="monotone"
                  dataKey={"visitas"}
                  stroke={reportHelper.colors[6]}
                  fill={reportHelper.colors[6]}
                />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
